export default "__VITE_ASSET__B7_WO1Cu__"